export const mapBookings = (response) => {
  if (response && response.data && response.data.success === true) {
    const rows = Array.isArray(response.data.data)
      ? response.data.data.map((b) => ({
          id: b.id,
          slack: b.slack,
          event_code: b.event_code,
          event_type: b.event_type,
          start_date: b.start_date,
          end_date: b.end_date,
          name: b.name,
          email: b.email,
          phone: b.phone,
          description: b.description,
          no_of_persons: b.no_of_persons,
          created_at: b.created_at,
          updated_at: b.updated_at,
          created_by: b.created_by,
          updated_by: b.updated_by,
          store: b.store
        }))
      : []
    return {
      success: true,
      total: response.data.total || rows.length,
      data: rows
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch bookings',
    data: []
  }
}

export const mapBookingDetail = (response) => {
  console.log('mapBookingDetail called with response:', response)
  if (response && response.data && response.data.success === true) {
    const b = response.data.data || {}
    console.log('Booking data:', b)
    const detail = {
      id: b.id,
      slack: b.slack,
      event_code: b.event_code,
      event_type: b.event_type,
      start_date: b.start_date,
      end_date: b.end_date,
      name: b.name,
      email: b.email,
      phone: b.phone,
      description: b.description,
      no_of_persons: b.no_of_persons,
      created_at: b.created_at || b.createdAt,
      updated_at: b.updated_at || b.updatedAt,
      created_by: b.created_by,
      updated_by: b.updated_by,
      store: b.store
    }
    console.log('Mapped detail:', detail)
    return { success: true, data: detail }
  }
  console.log(
    'mapBookingDetail failed:',
    response?.data?.message || 'Failed to fetch booking'
  )
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch booking'
  }
}
